/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

export default class ActiveEncoderStatusViewStyles {
    static STYLES = Object.freeze({
        main: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '0px 20px 0px 0px',
            verticalAlign: 'super'
        },
        logoContainer: {

        },
        encodersOuterContainer: {

        },
        encodersInnerContainer: {

        }
    });

    static getMain() {
        return ActiveEncoderStatusViewStyles.STYLES.main;
    }

    static getLogoContainer() {
        return ActiveEncoderStatusViewStyles.STYLES.logoContainer;
    }

    static getEncodersOuterContainer() {
        return ActiveEncoderStatusViewStyles.STYLES.encodersOuterContainer;
    }

    static getEncodersInnerContainer() {
        return ActiveEncoderStatusViewStyles.STYLES.encodersInnerContainer;
    }
}
